import { useEffect, useSyncExternalStore } from 'react'

import {
  getDeveloperModeSnapshot,
  hydrateDeveloperMode,
  subscribeToDeveloperMode,
} from '../services/developer-mode'

export function useDeveloperMode(): boolean {
  const isEnabled = useSyncExternalStore(
    subscribeToDeveloperMode,
    getDeveloperModeSnapshot,
    getDeveloperModeSnapshot,
  )

  useEffect(() => {
    void hydrateDeveloperMode()
  }, [])

  return isEnabled
}
